import { Rights } from '../models/enums/rights';

/**
 * Classe contenant les clés des données des routes.
 */
export class RouteData {
    constructor(
        public expectedRights: Rights[],
        public global?: boolean
    ) {}
}
